module.exports = __webpack_public_path__ + "img/img1.42162420.png";